import { Box, Button, Heading, Input, Stack } from '@vouched.id/vault';
import React, { useCallback, useState } from 'react';
// eslint-disable-next-line import-x/no-named-as-default
import ReCAPTCHA from 'react-google-recaptcha';
import { useLocation, useNavigate } from 'react-router-dom';
import { EGGPLANT_BUTTON_STYLE } from 'components/reusable/brand-button-style';
import { VouchedLogo } from 'components/reusable/vouched-logo';
import { appConfig } from 'config';
import { setAuthData, setMessages } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import { resetPassword } from 'store/sagas/sagas';
export const ResetPassword = () => {
    const { dispatch, asyncDispatch } = useGlobalState();
    const navigate = useNavigate();
    const [invalidConfirm, setInvalidConfirm] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [token, setToken] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { sid } = useLocation().state;
    const handleChangePassword = (e) => {
        const pw = e.target.value;
        setPassword(pw);
        if (pw === '' && confirmPassword === '') {
            setInvalidConfirm(false);
            return;
        }
        if (confirmPassword !== '') {
            setInvalidConfirm(pw !== confirmPassword);
        }
    };
    const handleChangeConfirmPassword = useCallback((e) => {
        const confirm = e.target.value;
        setConfirmPassword(confirm);
        setInvalidConfirm(confirm !== password);
    }, [password]);
    const handleToken = useCallback((e) => {
        setToken(e.target.value);
    }, []);
    const submit = (event) => {
        event.preventDefault();
        if (!isLoading && password && confirmPassword && !invalidConfirm) {
            setIsLoading(true);
            asyncDispatch(resetPassword({ password, token, sid, recaptchaToken }))
                .then((data) => {
                dispatch(setAuthData(data));
                navigate('/account');
                dispatch(setMessages({
                    value: 'Password changed successfully',
                    severity: 'success'
                }));
            })
                .catch((error) => {
                console.error(error);
            })
                .finally(() => {
                setIsLoading(false);
            });
        }
    };
    return (React.createElement(Box, { alignItems: "flex-start", display: "flex", height: "100vh", justifyContent: "center", padding: "spacing.large", style: { boxSizing: 'border-box' }, tag: "main" },
        React.createElement(Box, { alignItems: "center", display: "flex", flexDirection: "column", height: "100%", maxWidth: "52rem" },
            React.createElement(Box, { marginBottom: "spacing.xlarge" },
                React.createElement(VouchedLogo, { maxWidth: "100%", variant: "blue", width: "200px" })),
            React.createElement(Box, { marginBottom: "spacing.large" },
                React.createElement(Heading, { style: { fontWeight: 'bold' }, tag: "h1", variation: "h3" }, "Reset Password")),
            React.createElement(Box, { noValidate: true, onSubmit: submit, tag: "form", width: "100%" },
                React.createElement(Stack, { spacing: "spacing.large" },
                    React.createElement(Box, null,
                        React.createElement(Input, { inputMode: "text", label: "Password", name: "password", onChange: handleChangePassword, required: true, type: "password" })),
                    React.createElement(Box, null,
                        React.createElement(Input, { inputMode: "text", isInvalid: invalidConfirm, label: "Confirm Password", name: "confirm-password", onChange: handleChangeConfirmPassword, required: true, type: "password", validationMessage: "Passwords do not match." })),
                    React.createElement(Box, null,
                        React.createElement(Input, { helperText: "Please check your email for a reset code.", inputMode: "text", label: "Verification Code", name: "verification-code", onChange: handleToken, required: true, type: "text" })),
                    React.createElement(ReCAPTCHA, { onChange: setRecaptchaToken, sitekey: appConfig.recaptchaKey }),
                    React.createElement(Box, { alignItems: "center", display: "flex", justifyContent: "center", width: "100%" },
                        React.createElement(Button, { "data-cy": "submit", style: EGGPLANT_BUTTON_STYLE, title: isLoading ? 'loading' : '' }, "Reset Password")))))));
};
